import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import AlertSection from '../alert-section/alert-section.component'

const FormsPendingIndividualAlert = ({ formsPending }) => {
  const { t } = useTranslation(['common', 'checkIn'])
  const hasMultipleFormsPending = formsPending.length > 1

  return (
    <AlertSection
      type="forms"
      title={t('checkIn:formsPending')}
      count={
        hasMultipleFormsPending
          ? t('checkIn:totalFormsCard', { count: formsPending.length })
          : undefined
      }
      description={formsPending.join(', ')}
    />
  )
}

FormsPendingIndividualAlert.propTypes = {
  formsPending: PropTypes.array,
}

export default FormsPendingIndividualAlert
